import * as React from 'react';

import { Underground } from './Underground';
import { IUnderground } from '../../types/geo';

export interface IUndergroundsProps {
  undergrounds: IUnderground[];
}

export function Undergrounds({ undergrounds }: IUndergroundsProps) {
  return (
    <>
      {undergrounds.map(underground => {
        return <Underground key={underground.name} {...underground} />;
      })}
    </>
  );
}
